/**
 * #352 I1 — how a tab that did NOT send the prompt learns of the run fast.
 *
 * Every tab showing a session gets its `client-tool-request` only on an attached
 * run stream, and a tab that can't resolve the call's surface claims after ~8 s so
 * a tab that can wins. That holds only if the capable tab is attached in time. Its
 * one discovery path used to be the busy poll, which idles at 15 s — so the sender
 * that couldn't resolve the call won routinely (e2e on stagetest, #1119).
 *
 * The tenant's `/api/agent/event` stream already carries every part the run
 * writes. A part of the DISPLAYED session that this page isn't streaming means a
 * run started elsewhere: nudge the busy poll now (its effect attaches). Throttled
 * per session — a streaming run publishes many parts.
 */
export const FOREIGN_RUN_NUDGE_MIN_MS = 2_000

const lastNudgeAt = new Map<string, number>()

export function shouldNudgeForeignRun(input: { evSid: string; displayedSid: string | null; streaming: boolean; now?: number }): boolean {
  const { evSid, displayedSid, streaming } = input
  if (streaming || !displayedSid || evSid !== displayedSid) return false
  const now = input.now ?? Date.now()
  const last = lastNudgeAt.get(evSid)
  if (last !== undefined && now - last < FOREIGN_RUN_NUDGE_MIN_MS) return false
  // Bounded: only displayed sessions ever land here; drop stale ones past a handful.
  if (lastNudgeAt.size > 32) {
    for (const [k, t] of lastNudgeAt) if (now - t >= FOREIGN_RUN_NUDGE_MIN_MS) lastNudgeAt.delete(k)
  }
  lastNudgeAt.set(evSid, now)
  return true
}

/** Test-only. */
export function __resetForeignRunNudgesForTest(): void { lastNudgeAt.clear() }
